export enum ConnectWalletStep {
  CHOOSE_WALLET,
  NEON_CONNECT,
  NEOLINE_CONNECT,
  ONEGATE_CONNECT,
  WALLET_CONNECT,
}
